
/* Runs the stone texture straight through the join above the footer, on every
   page (18 Sep 2026). It looks at the nearest section above that carries a tiled
   texture, adopts that section's image and tile size, and sets its own phase so
   the tile continues from exactly where that section left off. If the section
   above is a plain light one (paper or limewash), the footer keeps its own stone
   tile and simply starts. */
(function(){
  var f=document.querySelector('.sfoot'); if(!f) return;
  function textured(){
    var el=f.previousElementSibling;
    while(el){
      var cs=getComputedStyle(el), bi=cs.backgroundImage||'', bs=cs.backgroundSize||'', m=bs.match(/^(\d+(?:\.\d+)?)px/);
      if(bi.indexOf('url(')>-1 && m && el.getBoundingClientRect().height>40) return {el:el,img:bi,tile:parseFloat(m[1])};
      el=el.previousElementSibling;
    }
    return null;
  }
  function a(){
    var t=textured(), y=f.getBoundingClientRect().top+window.pageYOffset;
    if(t){
      var cs=getComputedStyle(t.el), py=parseFloat(cs.backgroundPositionY)||0,
          top=t.el.getBoundingClientRect().top+window.pageYOffset,
          off=(py-(y-top))%t.tile; if(off>0) off-=t.tile;
      f.style.backgroundImage=t.img; f.style.backgroundSize=t.tile+'px auto';
      f.style.backgroundPositionX=cs.backgroundPositionX||'center';
      f.style.backgroundPositionY=Math.round(off)+'px';
    } else {
      f.style.backgroundSize='1024px auto';
      f.style.backgroundPositionY=(-(Math.round(y)%1024))+'px';
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',a); else a();
  window.addEventListener('load',a); window.addEventListener('resize',a);
  if(window.ResizeObserver){ new ResizeObserver(a).observe(document.body); }
})();
